module.exports = __webpack_public_path__ + "media/public/fonts/QanelasSemiBold/QanelasSemiBold-ec2f2ae628e57b7d3db0f91671a863b2.eot";